module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('notifications', {
    attrs: {
      "group": "foo-css",
      "position": "bottom left",
      "speed": 500
    }
  }), _vm._v(" "), _c('notifications', {
    attrs: {
      "group": "foo-velocity",
      "position": "bottom right",
      "animation-type": "velocity",
      "speed": 500
    }
  }), _vm._v(" "), _c('notifications', {
    attrs: {
      "group": "custom-style",
      "position": "top center",
      "classes": "n-light",
      "width": 400
    }
  }), _vm._v(" "), _c('notifications', {
    attrs: {
      "group": "custom-template",
      "duration": 5000,
      "width": 500,
      "animation-name": "v-fade-left",
      "position": "top left"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('div', {
          staticClass: "custom-template"
        }, [_c('div', {
          staticClass: "custom-template-icon"
        }, [_c('i', {
          staticClass: "icon ion-android-checkmark-circle"
        })]), _vm._v(" "), _c('div', {
          staticClass: "custom-template-content"
        }, [_c('div', {
          staticClass: "custom-template-title"
        }, [_vm._v("\n            " + _vm._s(props.item.title) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "custom-template-text",
          domProps: {
            "innerHTML": _vm._s(props.item.text)
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "custom-template-close",
          on: {
            "click": props.close
          }
        }, [_c('i', {
          staticClass: "icon ion-android-close"
        })])])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n      CSS animation:\n    ")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "success",
    staticStyle: {
      "width": "30%"
    },
    on: {
      "click": function($event) {
        _vm.show('foo-css', 'success')
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-information-circled"
  }), _vm._v("\n        SUCCESS\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "warn",
    staticStyle: {
      "width": "30%"
    },
    on: {
      "click": function($event) {
        _vm.show('foo-css', 'warn')
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-alert-circled"
  }), _vm._v(" \n        WARNING\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "error",
    staticStyle: {
      "width": "30%"
    },
    on: {
      "click": function($event) {
        _vm.show('foo-css', 'error')
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-close-circled"
  }), _vm._v("\n        ERROR\n      ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n      Velocity animation: \n    ")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "success",
    staticStyle: {
      "width": "30%"
    },
    on: {
      "click": function($event) {
        _vm.show('foo-velocity', 'success')
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-information-circled"
  }), _vm._v("\n        SUCCESS\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "warn",
    staticStyle: {
      "width": "30%"
    },
    on: {
      "click": function($event) {
        _vm.show('foo-velocity', 'warn')
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-alert-circled"
  }), _vm._v(" \n        WARNING\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "error",
    staticStyle: {
      "width": "30%"
    },
    on: {
      "click": function($event) {
        _vm.show('foo-velocity', 'error')
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-close-circled"
  }), _vm._v("\n        ERROR\n      ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('p', [_vm._v("Custom style:")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.show('custom-style')
      }
    }
  }, [_vm._v("\n        top center\n      ")]), _vm._v(" "), _c('p', [_vm._v("Custom template:")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.show('custom-template')
      }
    }
  }, [_vm._v("\n        top left\n      ")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Vue.js Notification\n    "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/euvl/vue-notification/blob/master/README.md",
      "target": "readme"
    }
  }, [_vm._v("Readme")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/euvl/vue-notification/",
      "target": "issues"
    }
  }, [_vm._v("Github")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46e720b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 11
// module chunks = 0